import { render } from "./AdminExtratosView.vue?vue&type=template&id=ae804caa&scoped=true"
import script from "./AdminExtratosView.vue?vue&type=script&lang=js"
export * from "./AdminExtratosView.vue?vue&type=script&lang=js"

import "./AdminExtratosView.vue?vue&type=style&index=0&id=ae804caa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae804caa"]])

export default __exports__